import { render, staticRenderFns } from "./SocialMediaShare.vue?vue&type=template&id=302bbe89"
import script from "./SocialMediaShare.vue?vue&type=script&lang=js"
export * from "./SocialMediaShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports